module.exports = __webpack_public_path__ + "media/images/happy_2-f25f0d52dce149459e65f31830cc8cdd.svg";